import React from "react";
import { Workflow, ShieldCheck, Gauge, Cpu } from "lucide-react";
import AdvancedLLMTestingConsole from "../components/AdvancedLLMTesting";

const capabilityCards = [
  {
    label: "Routage",
    value: "Profils",
    description:
      "Basculez en temps reel entre des presets standard, creatif et precis.",
    icon: Workflow,
  },
  {
    label: "Securite",
    value: "Scopes token",
    description:
      "Validez les tokens bearer, cles sandbox et identifiants expirants en ligne.",
    icon: ShieldCheck,
  },
  {
    label: "Latence",
    value: "Graphiques live",
    description:
      "Comparez les temps streaming et batch pour benchmarker les releases candidates.",
    icon: Gauge,
  },
  {
    label: "Modeles",
    value: "Double stack",
    description: "Testez les endpoints Qwen 3 et Llama 3.3 depuis une meme console.",
    icon: Cpu,
  },
];

const AdvancedLLMTestingPage = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#030816] text-white">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950" />
        <div className="absolute -top-24 left-1/4 h-[28rem] w-[28rem] rounded-full bg-cyan-500/25 blur-[160px]" />
        <div className="absolute bottom-0 right-0 h-[26rem] w-[26rem] rounded-full bg-indigo-500/20 blur-[140px]" />
        <div className="absolute inset-0 opacity-20">
          <div className="h-full w-full [background:radial-gradient(circle_at_1px,_rgba(255,255,255,0.12)_1px,_transparent_0)] [background-size:34px_34px]" />
        </div>
      </div>

      <div className="relative z-10 px-4 pt-6 pb-12 sm:px-8 lg:px-12 space-y-8">
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-xl shadow-2xl shadow-indigo-500/20">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-3xl font-semibold text-white">
                Environnement d'evaluation conversationnelle
              </h1>
              <p className="mt-2 text-sm text-slate-300 max-w-3xl">
                Testez les prompts longs, les deltas de streaming et le
                routage de persona depuis une console unique adaptee a la pile
                IA ePV.
              </p>
            </div>
            <div className="rounded-3xl border border-white/10 bg-slate-950/40 px-6 py-4 text-right">
              <p className="text-xs uppercase tracking-[0.4em] text-cyan-200/70">
                Profil de charge
              </p>
              <p className="mt-3 text-3xl font-semibold text-white">
                70B + Turbo
              </p>
              <p className="text-xs text-slate-400">Qwen 3 · Llama 3.3</p>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            {capabilityCards.map((card) => {
              const Icon = card.icon;
              return (
                <div
                  key={card.label}
                  className="rounded-2xl border border-white/10 bg-slate-900/70 p-4"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
                        {card.label}
                      </p>
                      <p className="mt-2 text-xl font-semibold text-white">
                        {card.value}
                      </p>
                    </div>
                    <div className="rounded-2xl border border-white/10 bg-white/5 p-2">
                      <Icon className="h-5 w-5 text-cyan-200" />
                    </div>
                  </div>
                  <p className="mt-3 text-xs text-slate-400">
                    {card.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="rounded-3xl border border-white/10 bg-slate-900/70 p-6 shadow-xl shadow-black/30">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-cyan-200/70">
                Atelier
              </p>
              <h2 className="mt-2 text-2xl font-semibold text-white">
                Console avancee de test LLM
              </h2>
              <p className="text-sm text-slate-300">
                Validez les reponses streaming, les prompts persona et la
                gestion d'erreurs sur l'endpoint LLM de production.
              </p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-slate-200">
              Endpoint: /llm/chat/completions
            </div>
          </div>
          <div className="mt-6 rounded-2xl border border-white/5 bg-slate-950/40 p-4">
            <AdvancedLLMTestingConsole />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedLLMTestingPage;
